import React from 'react'
import { Form, Input } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import constants from '../../config/constants'

import styled from 'styled-components'
import Button from '../../components/Button';

const FormItem = styled(Form.Item)`
  margin-bottom: 2.5rem;
  margin-top: 1.5rem;

  input {
    height: 45px !important;
    font-size: 16px !important;
    border: 1px solid ${constants.color.lightDark} !important;
    width: 100%;
    padding: 4px 11px;
    border-radius: 8px;
    caret-color: ${constants.color.blue} !important;

    &:focus {
      border: 1px solid ${constants.color.blue} !important;
      box-shadow: none !important;
    }
  }
`
const OtherBusinessType = (props) => {

  console.log(props.location);

  const { getFieldDecorator } = props.form;

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        props.setOtherBusinessType(values.otherBusinessType);
        props.setBusinessType(180,null);
        props.history.go(-2)
      }
    });
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: {span: 24 },
  };

  return (
    <Layout title={'เลือกประเภทธุรกิจ'} backIcon={true} onClick={() => props.history.goBack()}>
      <h5 style={{marginTop: '2rem', marginBottom: '1rem'}}>อื่นๆ</h5>
        <Form {...formItemLayout}>
          <FormItem>
            {getFieldDecorator('otherBusinessType', {
              rules: [
                {
                  required: true,
                  message: 'กรุณาระบุ',
                }
              ],
              })(<Input placeholder="กรุณาระบุ"/>)}
          </FormItem>
        </Form>
        <Button
          textcolor={constants.color.white}
          bordercolor={constants.color.orange}
          backgroundcolor={constants.color.orange}
          text={'ตกลง'}
          disabled={false}
          width={'100%'}
          onClick={handleSubmit}/>
    </Layout>
  )
}

const mapDispatchToProps = {
  setOtherBusinessType: actions.setOtherBusinessType,
  setBusinessType: actions.setBusinessType,
}

const WrappedOtherBusinessType = Form.create({ name: 'otherBusinessType' })(OtherBusinessType);

const OtherBusinessTypeWithConnect = connect(null, mapDispatchToProps)(WrappedOtherBusinessType)

export default OtherBusinessTypeWithConnect
